import routerOptions0 from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@22.19.3_@vue+compiler-sfc@3.5.26_cac@6.7.14_db0_ksz4fmbyyibk373lwumado4cau/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}